import { ProfileType } from '../types';

export const getHomePath = (profileType: ProfileType | null) => {
  return profileType === 'Application manager' ? '/explore/mine' : '/explore/all';
};

export const hasTribeFilter = (profileType: ProfileType | null) => {
  const isOther = profileType === 'Other' || profileType === 'Architect' || profileType === 'Application manager';

  return isOther ? false : true;
};

export const hasRcFormat = (profileType: ProfileType | null) => {
  return profileType === 'CIO' ? true : false;
};

export const hasKpiView = (profileType: ProfileType | null) => {
  return profileType === 'CIO' || profileType === 'RC/Tribe manager' || profileType === 'Architect' ? true : false;
};

export const computeScopeRef = (scopeRefKey: string) => {
  switch (scopeRefKey) {
    case 'finops':
      return 'cost';
    case 'tbs':
      return 'cost';
    case 'sgmarkets':
      return 'sg-markets';
    default:
      return scopeRefKey;
  }
};